var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/$.redefine-all.js
// module id = 88
// module chunks = 0 1